import script from "./PreviewPc.vue?vue&type=script&setup=true&lang=ts"
export * from "./PreviewPc.vue?vue&type=script&setup=true&lang=ts"

import "./PreviewPc.vue?vue&type=style&index=0&id=68a3267a&scoped=true&lang=less"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68a3267a"]])

export default __exports__